import 'tslib';
import ReactDOM from 'react-dom';
import storeMgr from './utils/storeManager';
import routes from './router';
import './index.less';

const root = document.getElementById('root');

ReactDOM.render(routes(storeMgr.getStores()), root);
